<template>
  <v-container fluid fill-height align-start pa-0 class="pageWrap">
    <v-sheet class="contents-container">
      <i-card-vertical headerTitle="비상대응 매뉴얼 관리" device="web" :IsUseEditorBox="true">
        <template v-slot:EditorBox>
          <date-bar
            :firstDisplayDate="searchYear"
            :dateOnly="true"
            class="mx-1"
            label="조회년도"
            year
            full-width
            no-title
            @getDate="searchYearChanged"
          ></date-bar>
        </template>
        <template v-slot:body>
          <v-layout column>
            <v-col cols="12" md="12" class="row pa-0">
              <v-col cols="12" class="pa-0">
                <DxDataGrid
                  id="mainGrid"
                  width="100%"
                  class="layout-col-height00"
                  :ref="dxDataGridRef"
                  :data-source="gridMain"
                  :remote-operations="false"
                  :hover-state-enabled="true"
                  :allow-column-reordering="true"
                  :allow-column-resizing="true"
                  :row-alternation-enabled="true"
                  :column-auto-width="true"
                  :show-borders="true"
                  :show-row-lines="true"
                  :selection="{ mode: 'single' }"
                  key-expr="id"
                  :focused-row-enabled="true"
                >
                  <DxEditing mode="batch" :allow-updating="true" :select-text-on-edit-start="true" />

                  <DxSelection :select-all-mode="allMode" show-check-boxes-mode="always" mode="multiple" />
                  <DxColumn
                    data-field
                    data-type="string"
                    width="120px"
                    alignment="center"
                    caption
                    :allow-editing="false"
                    cell-template="actionTemplete"
                  ></DxColumn>
                  <template #actionTemplete="{ data: cellInfo }">
                    <div>
                      <v-btn color="primary" elevation="0" dark small @click="btnDetail(cellInfo)" class="grid-btn rounded">상세보기</v-btn>
                    </div>
                  </template>
                  <DxColumn
                    width="400px"
                    data-field="trainingNm"
                    data-type="string"
                    alignment="left"
                    caption="비상사태명"
                    :allow-editing="false"
                    css-class="devest-grid-header-require"
                  />

                  <DxColumn
                    width="400px"
                    data-field="trainingLocation"
                    data-type="string"
                    alignment="left"
                    caption="장소"
                    :allow-editing="false"
                    css-class="devest-grid-header-require"
                  />

                  <DxColumn
                    data-field="trainingCount"
                    width="100px"
                    :min-width="80"
                    data-type="String"
                    alignment="center"
                    caption="훈련 횟수"
                    edit-cell-template="checkBoxEditor"
                    :allow-editing="false"
                  />
                  <DxColumn
                    width="80px"
                    :min-width="80"
                    data-field="signWriterNm"
                    data-type="string"
                    alignment="center"
                    caption="작성자"
                    :allow-editing="false"
                  />

                  <template #checkBoxEditor="{ data: cellInfo }">
                    <DxCheckBox :readOnly="true" :value="cellInfo.value" />
                  </template>
                </DxDataGrid>
              </v-col>
            </v-col>
          </v-layout>
        </template>
        <!-- <template v-slot:drawer>
          <v-navigation-drawer
            v-model="procedureShow"
            width="75%"
            absolute
            right
            temporary
            class="feedback-area"
          >
            <ProcedureComponent :type="'00006'"/>
          </v-navigation-drawer>
        </template>-->
      </i-card-vertical>
      <v-sheet class="iCardRightWrap" :class="{ 'guide-highlight-add': guideHighlightAdd }">
        <i-card-right :useBtnList="buttonUseList" @btnSearch="btnSearch()" @btnAdd="btnAdd()" @btnDelete="btnDelete()"></i-card-right>
        <!-- <i-card-right>
          <template v-slot:customBtn>
            <i-icon-button
              color="btn_text"
              :text="'절차서'"
              :icon="'file'"
              @click="procedureShow = !procedureShow"
            ></i-icon-button>
          </template>
        </i-card-right>-->
      </v-sheet>
    </v-sheet>
  </v-container>
</template>
<script>
// components
import iCardVertical from '@/components/common/iCardVertical.vue'
import baseview from '@/views/base/baseview.vue' //20220414 LYJ base page 추가
import BaseDataGrid from '@/views/base/BaseDataGrid.vue' //20220509 LYJ 데이타 그리드 사용시 베이스 추가
import dateBar from '@/components/common/dateBar.vue'
// utils
import { AesEncrypt, AesDecrypt } from '@/utils/aes256'
import { getPreMonth, getYearFormat } from '@/utils/common.js'
// api
import { getEmergencyResponseTraining, deleteEmergencyResponseTraining } from '@/api/emergencyActionPlan/emergencyResponseTraining.js'
import { deleteFilesWithTarget } from '@/api/baseManage/fileUpload'
import ProcedureComponent from '@/views/procedure/components/ProcedureComponent.vue'

export default {
  mixins: [baseview, BaseDataGrid], //20220414 LYJ base page 추가
  name: 'EmergencyResponseTraining',
  components: {
    'i-card-vertical': iCardVertical,
    'date-bar': dateBar,
    // 절차서 컴포넌트
    ProcedureComponent,
  },
  data() {
    return {
      initCompId: '',
      dxDataGridRef: 'mainGrid',
      gridMain: [],
      valid: true,
      buttonUseList: [
        'btnSearch', //조회
        'btnAdd', //추가
        'btnDelete', //삭제
      ],
      allMode: 'allPages',
      searchYear: getYearFormat(getPreMonth(0)),
      // 절차서 컴포넌트
      procedureContent: '',
      procedureShow: false, // 절차서 보이기
      guideHighlightAdd: false, // 반기평가 이동 시 추가하기 버튼 깜빡임
      _guideHighlightTimer: null,
    }
  },
  computed: {
    mobileTrigger: function () {
      return this.getWidth() < 1920
    },
  },
  watch: {
    // 반기 이행평가에서 같은 경로로 재이동할 때(query._t) 가이드 하이라이트/상세 이동 재적용
    '$route.query._t'(val, oldVal) {
      // keep-alive 잔존 시 다른 라우트의 _t 변경에도 반응하므로 현재 라우트만 처리
      if (this.$route.name !== 'EmergencyResponseTraining') return
      if (val && oldVal && val !== oldVal) {
        this.applyRouteFromEvaluation()
      }
    },
  },
  created() {},
  beforeMount() {},
  mounted() {
    // 초기 페이지 진입 시 compId 세팅
    this.initCompId = this.getCompId()
    this.btnSearch()
    this.applyRouteFromEvaluation()
  },
  beforeDestroy() {
    if (this._guideHighlightTimer) {
      clearTimeout(this._guideHighlightTimer)
      this._guideHighlightTimer = null
    }
  },
  activated() {
    if (this.$route.name !== 'EmergencyResponseTraining') return
    if (this.$route.params?.data?.guideHighlight) {
      this.applyRouteFromEvaluation()
    }
    if (this.$route.params?.search) {
      // 디테일 페이지에서 삭제, 추가 등 이벤트 발생 후 그리드 페이지 진입할 때
      this.btnSearch()
    }
    if (this.changedCompFlag(this.initCompId)) {
      // 로컬 스토리지에 저장된 값을 비교하여 변경 전 / 변경 후 compId가 다르고,
      // 페이지 진입시 세팅해두었던 compId 와 변경 후 compId와 다를 경우
      this.initCompId = this.getCompId()
      this.btnSearch()
    }
  },
  methods: {
    // 반기평가에서 진입: 문서가 있으면 상세(서명란)로, 없으면 추가 버튼 하이라이트
    applyRouteFromEvaluation() {
      if (this.$route.name !== 'EmergencyResponseTraining') return
      const routeData = this.$route.params && this.$route.params.data
      if (!routeData || !routeData.guideHighlight) return

      if (routeData.docNo) {
        this.$router.push({
          name: 'EmergencyResponseTrainingDetail',
          params: { data: routeData },
          query: { _t: Date.now() },
        })
        return
      }

      if (this._guideHighlightTimer) {
        clearTimeout(this._guideHighlightTimer)
        this._guideHighlightTimer = null
      }
      this.guideHighlightAdd = false
      this.$nextTick(() => {
        this.guideHighlightAdd = true
        this._guideHighlightTimer = setTimeout(() => {
          this.guideHighlightAdd = false
          this._guideHighlightTimer = null
        }, 5000)
      })
    },
    searchYearChanged(year) {
      this.searchYear = String(year)
      this.btnSearch()
    },
    ///////////////////////////////////////
    /*       Toolbar Button Event        */
    ///////////////////////////////////////
    //------------------------------------------
    //  조회
    //------------------------------------------
    btnSearch(notify = true) {
      // this.gridInit(this.GetDataGrid(this.dxDataGridRef))
      this.openLoading('searching')
      let params = {
        clntId: this.getClntId(),
        compId: this.getCompId(),
        searchYear: this.searchYear,
      }
      getEmergencyResponseTraining(params, notify)
        .then((res) => {
          // 리스트 조회 API
          this.gridMain = res.list
        })
        .finally(() => {
          this.endLoading()
          this.gridInit(this.GetDataGrid(this.dxDataGridRef))
        })
    },
    //------------------------------------------
    //  추가
    //------------------------------------------

    btnAdd() {
      let data = {}
      Object.defineProperty(data, '__created__', {
        value: true,
        writable: true,
        enumerable: true,
        configurable: true,
      })
      const toRouter = {
        name: 'EmergencyResponseTrainingDetail',
        params: {
          data: data,
        },
      }
      this.$router.push(toRouter)
    },
    async btnDetail(cellInfo) {
      console.log('### cellInfo', cellInfo.data)
      const toRouter = {
        name: 'EmergencyResponseTrainingDetail',
        params: {
          // data: cellInfo.data
          data: {
            clntId: cellInfo.data.clntId,
            compId: cellInfo.data.compId,
            writeDt: cellInfo.data.writeDt,
            docNo: cellInfo.data.docNo,
            __created__: cellInfo.data.__created__,
          },
        },
      }
      this.$router.push(toRouter)
    },

    //------------------------------------------
    //  삭제
    //------------------------------------------
    async btnDelete() {
      let selectedRows = await this.GetDataGrid(this.dxDataGridRef).getSelectedRowsData()
      let statusTrueCnt = 0
      console.log(selectedRows)
      if (selectedRows.length === 0) {
        this.vToastify(this.$t('selectionData'), 'info')
        return
      }
      selectedRows.forEach((el) => {
        if (el.trainingCount) statusTrueCnt++
      })
      if (statusTrueCnt > 0) {
        this.vToastify(this.$t(`실시된 훈련은 삭제가 불가능합니다.(${statusTrueCnt}개 항목)`), 'info')
        return
      }
      this.vToastifyPrompt('삭제하시겠습니까?', 'info', (current) => {
        this.openLoading()
        deleteEmergencyResponseTraining(selectedRows, true)
          .then((res) => {
            console.log('## 삭제', res)
            selectedRows.forEach((el) => {
              let deleteParams = {
                clntId: el.clntId,
                targetType: '00012',
                targetId: `${el.clntId}_${el.writeDt}_${el.docNo}`,
              }
              deleteFilesWithTarget(deleteParams).then((res) => {
                //
              })
            })
          })
          .catch(() => {
            this.endLoading()
          })
          .finally(() => {
            this.endLoading()
            this.btnSearch(false)
          })
      })
    },
  },
}
</script>

<style lang="scss">
@keyframes guide-blink-red {
  0%,
  100% {
    color: inherit;
    box-shadow: inset 0 0 0 0 transparent;
    outline: 2px solid transparent;
    background-color: transparent;
  }
  50% {
    color: #f44336 !important;
    box-shadow: inset 0 0 0 2px rgba(244, 67, 54, 0.85);
    outline: 2px solid #f44336;
    background-color: rgba(244, 67, 54, 0.12);
  }
}

.guide-highlight-add .btn_btnAdd {
  animation: guide-blink-red 0.8s ease-in-out 5;
  border-radius: 8px;
}
</style>
